import { type PlaceholderOptions } from '@tiptap/extension-placeholder';
import { type Editor } from '@tiptap/react';

import { isEditorLive } from '@heidi/editor/core';
const activeHintByEditor = new WeakMap<Editor, string>();

const refreshPlaceholder = (editor: Editor) => {
  editor.view.dispatch(editor.state.tr.setMeta('canvasDelayedDictateHint', true));
};

export const withCanvasDelayedDictateHint =
  (fallback: PlaceholderOptions['placeholder']): PlaceholderOptions['placeholder'] =>
  (props) => {
    const hint = activeHintByEditor.get(props.editor);
    if (hint && props.node.type.name === 'paragraph') return props.hasAnchor ? hint : '';
    return typeof fallback === 'function' ? fallback(props) : fallback;
  };

export const showCanvasDelayedDictateHint = (editor: Editor, hint: string): boolean => {
  if (activeHintByEditor.get(editor) === hint) return false;
  activeHintByEditor.set(editor, hint);
  editor.view.dom.dataset.canvasDelayedDictateHint = 'true';
  refreshPlaceholder(editor);
  return true;
};

export const hideCanvasDelayedDictateHint = (editor: Editor): boolean => {
  const wasVisible = activeHintByEditor.delete(editor);
  if (isEditorLive(editor, 'hideCanvasDelayedDictateHint')) {
    delete editor.view.dom.dataset.canvasDelayedDictateHint;
    if (wasVisible) refreshPlaceholder(editor);
  }
  return wasVisible;
};
